<template>
  <div class="messagerie" :class="{ marginBandeau: $store.state.bandeau }">
    <div :class="{ contenu: true, mobile: mobileMode }">
      <div v-if="mobileMode && !messageView" class="bandeauContacts">
        <h3>Mes contacts</h3>
      </div>
      <ListeCorrespondants
        ref="listeCorrespondants"
        v-show="mobileMode === false || messageView === false"
        class="leftSide"
      />

      <div v-show="showMessages" class="rightSide">
        <div v-if="selectedResult" class="bandeauCorresp">
          <router-link :to="{ name: 'Messagerie' }" v-if="mobileMode">
            <div class="boutonRond messageRond">
              <img :src="'/assets/icons_' + $store.state.iconTheme + '/back.png'" />
            </div>
          </router-link>
          <div class="miniPhoto">
            <Photo :profile="selectedResult.result.profile" :pic="selectedResult.result.profile.mainPicture" thumb />
          </div>

          <router-link
            v-if="!selectedResult.result.profile.deleted"
            :to="{
              name: 'Profil',
              query: {
                p: selectedResult.result.profile.pseudo
              }
            }"
          >
            <Pseudo :profile="selectedResult.result.profile" />
            <h4>{{ selectedResult.result.profile.city.name }}</h4>
          </router-link>

          <span v-else>
            <Pseudo :profile="selectedResult.result.profile" />
            <h4>{{ selectedResult.result.profile.city.name }}</h4>
          </span>

          <transition name="fade" mode="out-in">
            <span key="typing" v-if="selectedResult.typing">
              <img :src="'/assets/icons_' + $store.state.iconTheme + '/edit.png'" />
            </span>
          </transition>
        </div>
        <ListeMessages ref="listeMessages" />

        <div v-if="$refs.listeMessages" class="read">
          <transition name="fade" mode="out-in">
            <span key="read" v-if="$refs.listeMessages.lastSentRead == 1">
              <img :src="'/assets/icons_' + $store.state.iconTheme + '/check.png'" />
              Votre dernier message a été lu
            </span>
          </transition>
        </div>

        <div v-if="canSend" class="textInput">
          <quill
            ref="quill"
            id="messagerie"
            v-model="editorData"
            prompt="Votre message..."
            @text-change="keydown"
            :popontop="true"
            :noendline="true"
            @enter="sendMessage"
          />
          <div class="boutonRond messageRond" @click="sendMessage">
            <img alt="Envoyer" src="/assets/icons/send.png" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Quill from "@/components/util/Quill";
import ListeCorrespondants from "@/components/messagerie/ListeCorrespondants";
import ListeMessages from "@/components/messagerie/ListeMessages";
import Photo from "@/components/profile/Photo";
import BasePage from "@/components/pages/BasePage";
import Pseudo from "@/components/profile/Pseudo";
import { idyuLoadProfile } from "@/assets/js/idyu/connect.js";
import { idyuMobileMode } from "@/assets/js/idyu/util.js";

export default {
  name: "Messagerie",
  components: { quill: Quill, ListeCorrespondants, ListeMessages, Photo, Pseudo },
  extends: BasePage,
  data() {
    return {
      selectedResult: null,
      messageView: false,
      editorData: "",
      correspondantsLoaded: null,
      initiated: false
    };
  },

  computed: {
    messages: function() {
      if (this.selectedResult == null) {
        return null;
      }
      const res = {
        currentPage: this.selectedResult.currentPage,
        list: this.selectedResult.messages,
        total: 0,
        profile: null
      };
      if (this.selectedResult.result) res.profile = this.selectedResult.result.profile;
      return res;
    },

    correspondants: function() {
      return this.$refs.listeCorrespondants.scrollableList;
    },

    mobileMode: function() {
      return idyuMobileMode(this.$store);
    },

    showMessages: function() {
      if (this.mobileMode === false) return true;
      return this.messageView;
    },

    canSend: function() {
      return this.selectedResult;
    }
  },

  beforeMount: function() {
    const thisObj = this;

    document.addEventListener("visibilitychange", function() {
      if (thisObj.$route.name === "Messagerie" && document.visibilityState === "visible") {
        thisObj.selectRouteCorrespondant(thisObj.$route);
      }
    });
  },

  methods: {
    keydown: function(quill, delta, oldDelta, source) {
      if (delta && delta.ops.length >= 1) {
        if (!delta.ops[0].delete) {
          this.$store.state.messager.startTyping(this.selectedResult.result.profile);
        }

        if (delta.ops[delta.ops.length - 1].insert == "\n" && source == "user") {
          this.sendMessage();
        }
      }
    },

    sendMessage: async function() {
      if (this.$store.state.profile.validated == false) {
        await alert(
          "Votre profil est en cours de modération !<br/><br/>" +
            "Vous pourrez envoyer des messages une fois votre profil vérifié."
        );
        return;
      }
      let text = this.editorData;
      if (!text || text.length == 0) return;
      const messageObj = {
        from: this.$store.state.profile,
        to: this.selectedResult.result.profile,
        deleted: false,
        read: false,
        warned: false,
        body: text,
        date: Date.now()
      };
      if (
        this.$refs.listeCorrespondants.bumpedResult &&
        this.selectedResult === this.$refs.listeCorrespondants.bumpedResult.component
      )
        this.$refs.listeCorrespondants.bumpedResult = null;
      this.selectedResult.insertMessage(messageObj);

      this.$store.state.messager.sendMessage(messageObj);
      this.$refs.quill.clear();
    },

    messageReceived: async function(msg) {
      let interlocutor = this.correspondants.findResult(msg.data.idFrom);

      if (!interlocutor) {
        if (msg.data.type !== "message") return;
        const profile = await idyuLoadProfile(parseInt(msg.data.idFrom));
        const result = { profile: profile };
        await this.$refs.listeCorrespondants.addResult(result);
        interlocutor = result;
      }

      const messageProfileBox = interlocutor.component;

      if (msg.data.type === "message") {
        const messageObj = this.createMessage(interlocutor.profile, msg.data.message);
        this.$refs.listeCorrespondants.scrollableList.pushToFirst(interlocutor);
        messageProfileBox.receiveMessage(messageObj);
      }

      if (msg.data.type === "typing") {
        if (interlocutor) {
          if (msg.data.message === "start") messageProfileBox.typing = true;
          else messageProfileBox.typing = false;
        }
      }

      if (msg.data.type === "messageRead") {
        if (interlocutor) {
          messageProfileBox.receivedRead();
        }
      }
    },

    alertReceived: function(msg) {
      const interlocutor = this.correspondants.findResult(msg.data.idFrom);
      const messageProfileBox = interlocutor.component;

      messageProfileBox.receiveAlert(msg);
    },

    createMessage: function(interlocutorProfile, body) {
      const messageObj = {
        from: interlocutorProfile,
        to: this.$store.state.profile,
        deleted: false,
        read: false,
        warned: false,
        body: body,
        date: Date.now()
      };

      return messageObj;
    },

    selectRouteCorrespondant: async function(route) {
      let routeId = parseInt(route.query.id);

      if (routeId) {
        this.$store.state.lastContact = routeId;
        await Vue.nextTick();

        let result = route.params.corresp;
        if (!result) {
          result = this.$refs.listeCorrespondants.find(routeId);
        }
        if (result) await this.$refs.listeCorrespondants.selectCorrespondant(result);
        else {
          let profile = route.params.profile;
          if (!profile) profile = await idyuLoadProfile(parseInt(routeId));

          if (!profile) {
            // Cannot find profile
            if (this.mobileMode === false) this.$refs.listeCorrespondants.selectFirst();
            return false;
          }

          const result = { profile: profile };
          await this.$refs.listeCorrespondants.bumpResult(result);
          await Vue.nextTick();
        }
      }
      return true;
    },

    init: async function() {
      this.correspondantsLoaded = this.$refs.listeCorrespondants.init();
      await this.correspondantsLoaded;
      this.$store.state.messager.addListener(this);
      this.$store.state.messager.addAlertListener(this);
    },

    routeEnter: function(to) {
      this.$refs.listeCorrespondants.removeBumped();
      if (to.query.id) {
        this.selectRouteCorrespondant(to);
      }
    }
  },

  beforeRouteUpdate(to, from, next) {
    if (this.mobileMode) {
      if (!to.query.id) this.messageView = false;
      else this.messageView = true;
    }

    if (to.query.id) {
      this.selectRouteCorrespondant(to);
    }
    next();
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/vars.scss";

.contenu {
  position: relative;
  display: grid;
  grid-template-columns: min-content auto;
  grid-gap: 5px;
}

.leftSide,
.rightSide {
  height: calc(100vh - 113px);
  height: calc(calc(var(--vh, 1vh) * 100) - 113px);
}

.marginBandeau {
  .leftSide,
  .rightSide {
    height: calc(100vh - 200px);
    height: calc(calc(var(--vh, 1vh) * 100) - 222px);
  }
}
.rightSide {
  display: grid;
  grid-template-rows: min-content 1fr min-content;
  align-content: end;
}

.mobile {
  grid-template-columns: auto;
}

.bandeauCorresp,
.bandeauContacts {
  display: grid;
  align-items: center;
  border-bottom: $light_border;

  padding-left: 5px;
  padding-right: 5px;

  .miniPhoto img {
    margin-top: 3px;
    margin-bottom: 3px;
    height: 60px;
    border-radius: 100%;
    box-shadow: $small_shadow;
  }
  h3 {
    margin-top: 5px;
    margin-bottom: 5px;
    color: $theme_color;
  }

  h4 {
    margin: 0;
    font-weight: normal;
  }
}

.bandeauCorresp {
  grid-gap: 10px;
  grid-template-columns: min-content 1fr auto;
}

.sendButton {
  position: absolute;
  bottom: 50px;
  right: 10px;
  border: $light_border;
  border-color: #aaa;
  border-radius: 5px;
  padding-left: 7px;
  padding-right: 10px;
  box-shadow: $small_shadow;
  cursor: pointer;
  img {
    vertical-align: middle;
  }
  &:hover {
    background: #ffffd6;
  }
}

.textInput {
  display: grid;
  grid-auto-flow: column;
  margin-top: 5px;
  grid-template-columns: 1fr auto;
  align-items: center;
  .boutonRond {
    margin-left: 10px;
    margin-right: 10px;
  }
}

.read {
  text-align: right;
  font-style: italic;
  font-size: 14px;
  margin-right: 5px;
  height: 1em;
  img {
    height: 14px;
    vertical-align: middle;
  }
}

@media screen and (max-width: $no_menuprogress) {
  .leftSide,
  .rightSide {
    height: calc(100vh - 85px);
    height: calc(calc(var(--vh, 1vh) * 100) - 85px);
  }

  .textInput {
    display: grid;
    grid-auto-flow: column;
    margin-top: 5px;
    grid-template-columns: 1fr auto;
    align-items: center;
  }

  .rightSide {
    display: grid;
    grid-template-rows: min-content 1fr min-content;
    align-content: end;
  }

  .bandeauCorresp {
    grid-template-columns: min-content min-content 1fr auto;
  }
}

@media screen and (max-width: $app_width) {
  .leftSide,
  .rightSide {
    height: calc(100vh - 100px);
    height: calc(calc(var(--vh, 1vh) * 100) - 93px);
  }

  .marginBandeau {
    .leftSide,
    .rightSide {
      height: calc(100vh - 213px);
      height: calc(calc(var(--vh, 1vh) * 100) - 203px);
    }
  }
}

@media screen and (max-width: 745px) {
  .marginBandeau {
    .leftSide,
    .rightSide {
      height: calc(100vh - 213px);
      height: calc(calc(var(--vh, 1vh) * 100) - 93px);
    }
  }
}
</style>
